document.addEventListener('click', (e) =>{
    const activeBtn = document.querySelector('.dropdown-active');

    if(activeBtn){
        const parent = activeBtn.parentElement;

        if (parent != e.target && !parent.contains(e.target)) { 
            activeBtn.click();
        }
    }
}); 